
import { openTermsModal } from '@/helpers/ModalDialogs'
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class TermsModalStory extends Vue {
  mounted() {
    openTermsModal(this.$t('termsModal.title') as string)
  }
}
